module.exports = __webpack_public_path__ + "img/portada.eeda5667.png";